import script from "./xueshengduotiao.vue?vue&type=script&setup=true&lang=js"
export * from "./xueshengduotiao.vue?vue&type=script&setup=true&lang=js"

import "./xueshengduotiao.vue?vue&type=style&index=0&id=58d50dbb&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58d50dbb"]])

export default __exports__